import { ref } from "vue";
import { ElMessage } from "element-plus";
import {
  getEnvironments,
  deleteEnvironment as deleteEnvApi,
  addEnvironment as addEnvApi,
} from "../api/envApi";
import type { Environment, EnvironmentForm } from "../types";
import { getUrlParam } from "../components/utils";

export function useEnvironments() {
  const activeIndex = ref<number>();
  const environments = ref<Environment[]>([]);
  const loading = ref(false);

  const loadEnvironments = async () => {
    loading.value = true;
    try {
      environments.value = await getEnvironments();
      if (environments.value.length > 0) {
        // 优先使用地址栏的envId
        const envIdFromUrl = getUrlParam("envId");
        if (
          envIdFromUrl &&
          environments.value.some((e) => e.id === parseInt(envIdFromUrl))
        ) {
          activeIndex.value = parseInt(envIdFromUrl);
        } else {
          // @ts-ignore
          activeIndex.value = environments.value[0].id;
        }
      } else {
        activeIndex.value = undefined;
      }
    } catch (error) {
      ElMessage.error(error || "加载环境列表失败");
    } finally {
      loading.value = false;
    }
  };

  // 创建环境
  const createEnvironment = async (form: EnvironmentForm) => {
    try {
      await addEnvApi(form);
      ElMessage.success("环境添加成功");
      await loadEnvironments();
      return true;
    } catch (error) {
      ElMessage.error(error || "添加环境失败");
      return false;
    }
  };

  // 删除环境
  const removeEnvironment = async (id: number) => {
    try {
      await deleteEnvApi(id);
      ElMessage.success("环境销毁成功");
      // 本地删除这个环境
      environments.value = environments.value.filter((e) => e.id !== id);
      if (activeIndex.value === id && environments.value.length > 0) {
        activeIndex.value = environments.value[0]?.id;
      } else {
        activeIndex.value = undefined;
      }
    } catch (error) {
      ElMessage.error(error || "销毁环境失败");
    }
  };

  const getEnvName = (id: number) => {
    const env = environments.value.find((e) => e.id === id);
    return env ? env.name : `Env #${id}`;
  };

  return {
    activeIndex,
    environments,
    loading,
    loadEnvironments,
    createEnvironment,
    removeEnvironment,
    getEnvName,
  };
}
